<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    v-on="$listeners"
    @click:outside="onCancel"
  >
    <v-card>
      <v-card-title>
        Atualizar Report
      </v-card-title>
      <v-card-text>
        <v-form
          ref="form"
        >
          <!-- <v-select
            v-model="category"
            :items="categoryOptions"
            item-text="text"
            item-value="value"
            label="Tipo de Report"
          /> -->
          <v-select
            v-model="status"
            :items="statusOptions"
            item-text="text"
            item-value="value"
            label="Status"
          />
        </v-form>
      </v-card-text>
      <v-card-text>
        <div class="d-flex justify-space-between">
          <v-btn
            color="primary"
            text
            @click="onCancel"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="updateFeedbackReport()"
          >
            Atualizar
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {

  props: {
    report: { type: Object, default: () => ({}) }
  },
  data: () => ({
    category: null,
    status: null,
    // categoryOptions: [
    //   { text: 'Bug', value: 'BUG' },
    //   { text: 'Melhoria', value: 'IMPROVEMENT' },
    //   { text: 'Dúvida', value: 'DOUBT' },
    //   { text: 'Outro', value: 'OTHER' }
    // ],
    statusOptions: [
      { text: 'Aberto', value: 'OPEN' },
      { text: 'Em andamento', value: 'INVESTIGATING' },
      { text: 'Resolvido', value: 'RESOLVED' },
      { text: 'Fechado', value: 'ARCHIVED' }
    ]
  }),

  watch: {
    report: {
      handler (newValue) {
        if (newValue) {
          // this.category = this.report.category
          this.status = this.report.status
        }
      },
      deep: true,
      immediate: true
    }
  },
  mouted () {
    // this.category = this.report.category
    this.status = this.report.status
  },
  methods: {
    async updateFeedbackReport () {
      const data = {
        category: this.category,
        status: this.status
      }
      try {
        await this.$api.updateFeedbackReport(this.report.id, data)

        this.$emit('resolve', true)
      } catch {
      }
    },

    onCancel () {
      this.$emit('resolve', false)
    }
  }
}
</script>
